import { useMemo } from "react";

export const useAllowableStatusSwitch = (status?: number) => {
  const statusMap: Record<number, number[]> = {
    3: [2, 4],
    4: [3],
    5: [2],
  };

  const possibleSwitch = useMemo(() => {
    if (typeof status !== "number") return [];
    return statusMap[status] ?? [];
  }, [status]);

  return { possibleSwitch };
};
